// extracted by mini-css-extract-plugin
module.exports = {"uploadVideoWrp":"areasOfFocus_uploadVideoWrp__2LAZ1","customPadding":"areasOfFocus_customPadding__2_Wms"};